// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2uSdR","author":"Table_author__2uIG2","authorImage":"Table_authorImage__9wECd","unreadRow":"Table_unreadRow__32f_B"};